import React from 'react'
import Downlinereport from '../../Component/TeamOverview/DownLine/Downlinereport'

const Downline = () => {
  return (
    <div className='page-body'>
      <Downlinereport/>
    </div>
  )
}

export default Downline